import { useAppSelector } from '../slices/index';
import { getUkDate } from '../utilities';

const ReportBricklane = () => {
	const cases = useAppSelector(state => state.cases);

	return (
		<table style={{ borderSpacing: 0, borderCollapse: 'collapse' }}>
			<thead>
				{(cases.report.rows || []).length > 0 &&
					<tr>
						<th>Property/Client Name/PLS Reference</th>
						<th>Casetype</th>
						<th>Casekey</th>
						<th>MatterTypeCode</th>
						<th>Fee Earner</th>
						<th>Introducer</th>
						<th>Case Status Description</th>
						<th>Client 01 Full Name</th>
						<th>Client 02 Full Name</th>
						<th>Transaction Property Address</th>
						<th>Transaction Property Postcode</th>
						<th>Tenure</th>
						<th>File Opened</th>
						<th>Start Month</th>
						<th>CCL Received</th>
						<th>Contract Sent</th>
						<th>Enquiries Received Date</th>
						<th>Enquiries Replied Date</th>
						<th>Contract Sent? Y/N</th>
						<th>Enquiries Received?</th>
						<th>Replied to Enquiries Received?</th>
						<th>LPE1sentToClient</th>
						<th>LPE1 to Client?</th>
						<th>LPE1 sent to Management Company</th>
						<th>LPEI to Management Company?</th>
						<th>Exchange Date</th>
						<th>Exchanged</th>
						<th>Completion Date Sale</th>
						<th>File Closed Date</th>
						<th>Matter Cancelled Date</th>
					</tr>
				}
			</thead>
			{(cases.report.rows || []).map((r: any) => {
				return (
					<tbody>
						<tr>
							<td>{r.TransactionPropertyAddress + ' / ' + r.Client01FullName + ' / ' + r.casekey}</td>
							<td>{r.casetype}</td>
							<td>{r.casekey}</td>
							<td>{r.MatterTypeCode}</td>
							<td>{r.FeeEarner}</td>
							<td>{r.Introducer}</td>
							<td>{r.CaseStatusDescription}</td>
							<td>{r.Client01FullName}</td>
							<td>{r.Client02FullName}</td>
							<td>{r.TransactionPropertyAddress}</td>
							<td>{r.TransactionPropertyPostcode}</td>
							<td>{r.Tenure}</td>
							<td>{getUkDate(r.FileOpened)}</td>
							<td>{r.StartMonth}</td>
							<td>{getUkDate(r.CCLReceived)}</td>
							<td>{getUkDate(r.ContractSent)}</td>
							<td>{getUkDate(r.EnquiriesReceivedDate)}</td>
							<td>{getUkDate(r.EnquiriesRepliedDate)}</td>
							<td>{r.ContractSentQ}</td>
							<td>{r.EnquiriesReceivedQ}</td>
							<td>{r.RepliestoEnquiriesReceivedQ}</td>
							<td>{r.LPE1sentToClient}</td>
							<td>{r.LPE1toClientQ}</td>
							<td>{getUkDate(r.LPE1senttoManagementCompany)}</td>
							<td>{r.LPE1toManagementCompanyQ}</td>
							<td>{getUkDate(r.ExchangeDate)}</td>
							<td>{r.Exchanged}</td>
							<td>{getUkDate(r.CompletionDateSale)}</td>
							<td>{getUkDate(r.FileClosedDate)}</td>
							<td>{getUkDate(r.MatterCancelledDate)}</td>
						</tr>
					</tbody>
				)
			})}
		</table>
	);
}

export default ReportBricklane;